module.exports = __webpack_public_path__ + "img/vertical_6_2_8017.8abcc6cc.png";